"use client";

import { SubscriptionContext } from "../subscription-context";
import InvoicePageContent from "./page-content";
import { ToastProvider } from "../../../components/ToastNotification/toastProvider";

const InvoicePage = () => {
  return (
    <SubscriptionContext cancelRequests>
      <InvoicePageContent />
      <ToastProvider />
    </SubscriptionContext>
  );
};

export default InvoicePage;
